<template>
  <div ref="login" class="login-container">
    <LoginHead></LoginHead>
    <div class="login-weaper animated bounceInDown" style="height:calc(100vh - 126px);width:100%;display: flex;">
      <div class="login-left">
        <!--<div class="login-time">
          一站式招采拍卖服务平台
           {{time}}
        </div>
        <div class="title">
          <div class="title-top">与齐鲁观水共创未来</div>
          <div class="title-content">欢迎加入齐鲁观水电子拍卖平台，在齐鲁观水，</div>
          <div class="title-content">您可以参与竞价、跟踪拍卖进度，</div>
          <div class="title-content">助您把握每一次价值机遇，更有金融支持保驾护航。</div>
          <div class="title-content">齐鲁观水，助力实现价值提升。</div>
        </div>-->
      </div>
      <div class="login-border">
        <div class="login-main">
          <div class="login-register cursor-pointer-text" @click="toRegister">
            <!-- 注册 -->
            没有账户？立即注册
          </div>
          <br><br>
          <h4 class="login-title">
            尊敬的竞买人，欢迎登录您的账户
          </h4>
          <div class="change-login-type">
            <span :class="loginType==0?'login-type-selected':'login-type cursor-pointer-text'"
                  @click="changeLoginType(0)">账户登录</span>
            <img class="login-change cursor-pointer-text" src="../../public/img/change.png" @click="changeLoginType">
            <span :class="loginType==1?'login-type-selected':'login-type cursor-pointer-text'"
                  @click="changeLoginType(1)">手机号登录</span>
          </div>
          <div class="login-type-div">
            <UserLogin v-if="loginType == 0"></UserLogin>
            <CodeLogin v-if="loginType == 1"></CodeLogin>
          </div>
          <!-- 登录类型按钮 -->
          <div class="login-menu">
            <!-- 注册 -->
            <img src="../../public/img/yellow-warning.png">
            <a href="#" @click="toDownLoadOperationManual">点击查看操作指南</a><br>
            <img src="../../public/img/yellow-warning.png">
            <span style="color:rgba(214, 54, 59, 1)">平台技术电话：0531-85198189</span>
          </div>

        </div>
        <div class="login-bottom-phone">
            <span>
              客服电话 ：
            </span>
          <a href="#">0531-85198189/13256709656</a>
          <p>
            (工作日 8:30-17:30)
          </p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import LoginHead from '@/pages/login/LoginHead.vue'
import UserLogin from "./login/userlogin";
import CodeLogin from "./login/codelogin.vue"
import {dateFormat} from "@/util/date";
import {cmsGetUrl} from '@/api/system/param';
// import {getQueryString, getTopUrl} from "@/util/util";
export default {
  name: "LoginVue",
  components: {
    UserLogin,
    CodeLogin,
    LoginHead
  },
  data() {
    return {
      time: "",
      activeName: "user",
      socialForm: {
        tenantId: "000000",
        source: "",
        code: "",
        state: "",
      },
      loginType: 0,
    };
  },
  watch: {
    $route() {
      // this.handleLogin();
    },
  },
  created() {
    // this.handleLogin();
    this.getTime();
  },
  mounted() {
  },
  props: [],
  methods: {
    toDownLoadOperationManual(type) {
      this.$router.push({path: "/help", query: {type}})

    },
    changeLoginType(type) {
      if (type == 0 || type == 1) {
        this.loginType = type;
      } else {
        this.loginType = (this.loginType + 1) % 2
      }
    },
    getTime() {
      setInterval(() => {
        this.time = dateFormat(new Date());
      }, 1000);
    },
    // handleLogin() {
    //   const topUrl = getTopUrl();
    //   const redirectUrl = "/oauth/redirect/";
    //   // const ssoCode = "?code=";
    //   this.socialForm.source = getQueryString("source");
    //   this.socialForm.code = getQueryString("code");
    //   this.socialForm.state = getQueryString("state");
    //   if (validatenull(this.socialForm.source) && topUrl.includes(redirectUrl)) {
    //     let source = topUrl.split("?")[0];
    //     source = source.split(redirectUrl)[1];
    //     this.socialForm.source = source;
    //   }
    // },
    toRegister() {
      cmsGetUrl({paramKey: 'registerUrl'}).then(res => {
        let url = res.data.data.paramValue
        window.open(url)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/login.scss";
</style>
